/* eslint-disable radix */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { APP_UI } from 'pages/ApplicationUI/constant';
import NewsDataList from './components/NewsDataList';
import AddEditNews from './components/AddEditNews';

const News = ({ saveUISetting }) => {
  const [showAddEditRecord, setShowAddEditRecord] = useState({
    type: ADD_EDIT_CONSTANT.ADD,
    value: '',
    refetch: () => {},
    status: false,
  });
  const [deleteRecord, setDeleteRecord] = useState({
    status: false,
    id: '',
    refetch: () => {},
  });

  const toggleDeleteRecord = (id, refetch = () => {}) => {
    setDeleteRecord({ status: !deleteRecord.status, id, refetch });
  };

  const onDeleteConfirmation = async () => {
    try {
      await saveUISetting({
        variables: {
          appUISetting: {
            id: deleteRecord?.id,
            settingName: APP_UI.NEWS,
            settingValue: '',
            isActive: false,
          },
        },
      });
      deleteRecord.refetch();
      setDeleteRecord({
        status: !deleteRecord.status,
        id: '',
        refetch: () => {},
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const drawerToggle = (value, type, refetch = () => {}) => {
    setShowAddEditRecord({
      type,
      value,
      refetch,
      status: !showAddEditRecord?.status,
    });
  };

  return (
    <>
      <FSBModal
        title={`${showAddEditRecord?.type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Create'}
 News`}
        open={showAddEditRecord?.status}
        toggleAlert={drawerToggle}
        onClose={drawerToggle}
        message=""
        modalClass="right-drawer"
      >
        <AddEditNews
          type={showAddEditRecord.type}
          value={showAddEditRecord.value}
          refetch={showAddEditRecord.refetch}
          saveUISetting={saveUISetting}
          toggleFAQForm={drawerToggle}
        />
      </FSBModal>
      <DeleteConfirmationAlert
        open={deleteRecord.status}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <h4 className="f-16 fw-semibold mb-3">News</h4>

      <NewsDataList
        saveUISetting={saveUISetting}
        toggleDeleteRecord={toggleDeleteRecord}
        handleClickEdit={drawerToggle}
      />
    </>
  );
};

export default News;
